import useBrand from 'hooks/useBrand'

import styles from './Hero.module.scss'

const SavibookHero = ({ children, solidBg }) => {
  const { colors } = useBrand()

  return (
    <div className={styles.hero} style={{ background: colors.primary }}>
      <div className={solidBg ? styles.innerBlank : styles.inner}>{children}</div>
    </div>
  )
}

export default SavibookHero
